import React from "react";
import { Controller } from 'react-hook-form';

function InputField({ label, name, placeholder, control, readOnly = false }) {
    return (
        <Controller
            control={control}
            name={name}
            render={({ field: { onChange, value }, fieldState: { error } }) => (
                <div>
                    {
                        label && <label htmlFor=""
                                        className="checkout__label">{label}</label>
                    }
                    <input type="text"
                           id={name}
                           onChange={onChange}
                           value={value}
                           className={"checkout__input " + (error ? "checkout__input--error" : "")}
                           readOnly={readOnly}
                           placeholder={placeholder}/>
                    {error &&
                        <p className="checkout__input-validation-error">{error.message}</p>}
                </div>
            )}
        />
    );
}

export default InputField;
